"use client";

import { useAuthContext } from "@/components/providers/auth-provider";
import PageLoading from "@/components/shared/page-loading";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

function HomePageContent() {
  const router = useRouter();
  const { allowedScreens } = useAuthContext();

  useEffect(() => {
    if (allowedScreens && allowedScreens?.length > 0) router.push(allowedScreens?.[0]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, allowedScreens]);

  return <PageLoading />;
}

export default HomePageContent;
